// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__279u0","icon":"SortAdornment_icon__1mppq","up":"SortAdornment_up__1OX_h","down":"SortAdornment_down__3LUFd","active":"SortAdornment_active__3BBLl"};